import type { BoardObject } from '../../core/interfaces/board-object.interface.js';
import type { PersonObject } from './person.interface.js';

/**
 * Name-label defaults. They live here rather than in `person.renderer.ts`
 * so `person-defaults.factory.ts` can seed them without importing Konva.
 * The renderer re-exports `PERSON_FONT_SIZE` for its existing consumers.
 *
 * 14 world units is the size the label was hard-coded to before it became
 * configurable, so persisted persons that carry no `fontSize` still render
 * exactly as before.
 */
export const PERSON_FONT_SIZE = 14;

/** Regular weight — slot 2 of the shared `TEXT_WEIGHT_ACTIONS` widget. */
export const PERSON_DEFAULT_FONT_WEIGHT = 500;

/**
 * Type-narrowing guard for person board objects (TR2).
 *
 * Null- and undefined-safe per PRD-F2 T15 to keep registry fallbacks
 * (FC10) from throwing on absent payloads.
 */
export function isPerson(
  obj: BoardObject | null | undefined,
): obj is PersonObject {
  return obj != null && obj.type === 'person';
}
